const FONT = "13px system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";

let cachedCtx: CanvasRenderingContext2D | null = null;

function getCtx(): CanvasRenderingContext2D | null {
  if (cachedCtx) return cachedCtx;
  if (typeof document === "undefined") return null;
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  if (!ctx) return null;
  ctx.font = FONT;
  cachedCtx = ctx;
  return ctx;
}

export function measureText(s: string): number {
  if (!s) return 0;
  const ctx = getCtx();
  if (!ctx) return s.length * 7;
  return ctx.measureText(s).width;
}

export interface ColumnWidthOpts {
  min?: number;
  max?: number;
  paddingX?: number;
}

export type WidthInput = string | { text: string; extraPx?: number };

export function calculateColumnWidth(
  values: readonly (WidthInput | null | undefined)[],
  title: string,
  opts: ColumnWidthOpts = {},
): number {
  const { min = 80, max = 350, paddingX = 24 } = opts;
  let widest = measureText(title);
  for (const v of values) {
    if (!v) continue;
    const w = typeof v === "string" ? measureText(v) : measureText(v.text) + (v.extraPx ?? 0);
    if (w > widest) widest = w;
  }
  return Math.max(min, Math.min(max, Math.ceil(widest + paddingX)));
}
